import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IAdministrationState } from './state'
import { toNumberDictionary } from '@/utils/groupBy'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser'
import { AloMailSkin, getDefaultAloMailSkin } from '@/models/alo/AloMailSkin'
import { AloMailTemplate, getDefaultAloMailTemplate } from '@/models/alo/AloMailTemplate'
import { getDefaultAloMailTemplateLg } from '@/models/alo/AloMailTemplateLg'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloActivity, getDefaultAloActivity } from '@/models/alo/AloActivity'
import { AloForfait, getDefaultAloForfait } from '@/models/alo/AloForfait'
import { AloMns, getDefaultAloMns } from '@/models/alo/AloMns'
import { AloContact, getDefaultAloContact } from '@/models/alo/AloContact'
import { AloNewsletter, getDefaultAloNewsletter } from '@/models/alo/AloNewsletter'
import { AloCours, getDefaultAloCours } from '@/models/alo/AloCours'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { AloFamily, getDefaultAloFamily } from '@/models/alo/AloFamily'




const mutations: MutationTree<IAdministrationState> = {
    
    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////

    [types.ADM_USER_REQUEST]: state => {    
        state.userStatus = 'Chargement des user'
    },
    [types.ADM_USER_SUCCESS]: (state, user:Array<AloUser>) => {        
        state.userDic = {...state.userDic, ...toNumberDictionary(user,f => f.id,getDefaultAloUser)}
        state.userList = buildStateItem(user.map(f => f.id))
        state.userStatus = 'Chargement des user terminé'
    },
    [types.ADM_USER_ERROR]: (state,message:string) => {        
        state.userStatus = message ?? 'Erreur lors du chargement des user'
    },
    [types.ADM_USER_DETAIL_REQUEST]: state => {    
        state.userStatus = "Chargement du detail de user"
    },
    [types.ADM_USER_DETAIL_SUCCESS]: (state, user:AloUser) => {        
        Vue.set(state.userDic,user.id,{...getDefaultAloUser(),...user})
        state.userStatus = 'Chargement du detail user terminé'
    },
    [types.ADM_USER_DETAIL_ERROR]: (state,message:string) => {        
        state.userStatus = message ?? 'Erreur lors du chargement du detail user'
    },
    [types.ADM_USER_SAVE_REQUEST]: state => {    
        state.userStatus = "Sauvegarde de user"
    },
    [types.ADM_USER_SAVE_SUCCESS]: (state, user:AloUser) => {        
        Vue.set(state.userDic,user.id,{...getDefaultAloUser(),...user})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.userList.item.findIndex(n => n == user.id) == -1) state.userList.item.push(user.id)
        state.userStatus = "Sauvegarde de user terminée"
    },
    [types.ADM_USER_SAVE_ERROR]: (state,message:string) => {        
        state.userStatus = message ?? "Erreur lors de la sauvegarde de user"
    },    
    [types.ADM_USER_SAVE_MEMBER_REQUEST]: state => {    
        state.userStatus = "Sauvegarde de user"
    },
    [types.ADM_USER_SAVE_MEMBER_SUCCESS]: (state, user:AloUser) => {        
        /*Vue.set(state.userDic,user.id,{...getDefaultAloUser(),...user})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.userList.item.findIndex(n => n == user.id) == -1) state.userList.item.push(user.id)*/
        state.userStatus = "Sauvegarde de user terminée"

        //mise à jour de la famille si présente
        const fam = state.familyDic[user.famId!];
        if(fam && fam.detailLoaded) {
            const idx = fam.membres.findIndex(m => m.id == user.id)
            if(idx >= 0) fam.membres.splice(idx,1,user)
            else fam.membres.push(user)
        }
    },
    [types.ADM_USER_SAVE_MEMBER_ERROR]: (state, message:string) => {        
        state.userStatus = message ?? "Erreur lors de la sauvegarde de user"
    },    
    [types.ADM_USER_RESET_STATUS]: (state) => {
        state.userStatus = ''
    },
    [types.ADM_USER_DELETE_REQUEST]: state => {    
        state.userStatus = "Suppression de user"
    },
    [types.ADM_USER_DELETE_SUCCESS]: (state, user:AloUser) => {        
        const idx = state.userList.item.indexOf(user.id)
        if(idx > -1) state.userList.item.splice(idx ,1)
        delete state.userDic[user.id]                
        state.userStatus = "Suppression de user terminée"
    },
    [types.ADM_USER_DELETE_ERROR]: (state,message:string) => {        
        state.userStatus = message ?? "Erreur lors de la Suppression de user"
    },

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////

    [types.ADM_MAIL_TEMPLATE_REQUEST]: state => {    
        state.mailTemplateStatus = 'Chargement des mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_SUCCESS]: (state, mailTemplate:Array<AloMailTemplate>) => {        
        state.mailTemplateDic = {...state.mailTemplateDic, ...toNumberDictionary(mailTemplate,f => f.id,getDefaultAloMailTemplate)}
        state.mailTemplateList = buildStateItem(mailTemplate.map(f => f.id))
        state.mailTemplateStatus = 'Chargement des mailTemplate terminé'
    },
    [types.ADM_MAIL_TEMPLATE_ERROR]: (state,message:string) => {        
        state.mailTemplateStatus = message ?? 'Erreur lors du chargement des mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST]: state => {    
        state.mailTemplateStatus = "Chargement du detail de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {                
        mailTemplate.lgs = mailTemplate.lgs.map(it => {return {...getDefaultAloMailTemplateLg(it.lg),...it}})        
        Vue.set(state.mailTemplateDic,mailTemplate.id,{...getDefaultAloMailTemplate(),...mailTemplate})
        state.mailTemplateStatus = 'Chargement du detail mailTemplate terminé'
    },
    [types.ADM_MAIL_TEMPLATE_DETAIL_ERROR]: (state,message:string) => {        
        state.mailTemplateStatus = message??'Erreur lors du chargement du detail mailTemplate'
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_REQUEST]: state => {    
        state.mailTemplateStatus = "Sauvegarde de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {        
        Vue.set(state.mailTemplateDic,mailTemplate.id,{...getDefaultAloMailTemplate(),...mailTemplate})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.mailTemplateList.item.findIndex(n => n == mailTemplate.id) == -1) state.mailTemplateList.item.push(mailTemplate.id)
        state.mailTemplateStatus = "Sauvegarde de mailTemplate terminée"
    },
    [types.ADM_MAIL_TEMPLATE_SAVE_ERROR]: (state,message:string) => {        
        state.mailTemplateStatus = message??"Erreur lors de la sauvegarde de mailTemplate"
    },    
    [types.ADM_MAIL_TEMPLATE_RESET_STATUS]: (state) => {
        state.mailTemplateStatus = ''
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_REQUEST]: state => {    
        state.mailTemplateStatus = "Suppression de mailTemplate"
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_SUCCESS]: (state, mailTemplate:AloMailTemplate) => {        
        const idx = state.mailTemplateList.item.indexOf(mailTemplate.id)
        if(idx > -1) state.mailTemplateList.item.splice(idx ,1)
        delete state.mailTemplateDic[mailTemplate.id]                
        state.mailTemplateStatus = "Suppression de mailTemplate terminée"
    },
    [types.ADM_MAIL_TEMPLATE_DELETE_ERROR]: (state,message:string) => {        
        state.mailTemplateStatus = message??"Erreur lors de la Suppression de mailTemplate"
    },

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////

    [types.ADM_MAIL_SKIN_REQUEST]: state => {    
        state.mailSkinStatus = 'Chargement des mailSkin'
    },
    [types.ADM_MAIL_SKIN_SUCCESS]: (state, mailSkin:Array<AloMailSkin>) => {        
        state.mailSkinDic = {...state.mailSkinDic, ...toNumberDictionary(mailSkin,f => f.id,getDefaultAloMailSkin)}
        state.mailSkinList = buildStateItem(mailSkin.map(f => f.id))
        state.mailSkinStatus = 'Chargement des mailSkin terminé'
    },
    [types.ADM_MAIL_SKIN_ERROR]: (state,message:string) => {        
        state.mailSkinStatus = message??'Erreur lors du chargement des mailSkin'
    },
    [types.ADM_MAIL_SKIN_DETAIL_REQUEST]: state => {    
        state.mailSkinStatus = "Chargement du detail de mailSkin"
    },
    [types.ADM_MAIL_SKIN_DETAIL_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        Vue.set(state.mailSkinDic,mailSkin.id,{...getDefaultAloMailSkin(),...mailSkin})
        state.mailSkinStatus = 'Chargement du detail mailSkin terminé'
    },
    [types.ADM_MAIL_SKIN_DETAIL_ERROR]: (state,message:string) => {        
        state.mailSkinStatus = message??'Erreur lors du chargement du detail mailSkin'
    },
    [types.ADM_MAIL_SKIN_SAVE_REQUEST]: state => {    
        state.mailSkinStatus = "Sauvegarde de mailSkin"
    },
    [types.ADM_MAIL_SKIN_SAVE_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        Vue.set(state.mailSkinDic,mailSkin.id,{...getDefaultAloMailSkin(),...mailSkin})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.mailSkinList.item.findIndex(n => n == mailSkin.id) == -1) state.mailSkinList.item.push(mailSkin.id)
        state.mailSkinStatus = "Sauvegarde de mailSkin terminée"
    },
    [types.ADM_MAIL_SKIN_SAVE_ERROR]: (state,message:string) => {        
        state.mailSkinStatus = message??"Erreur lors de la sauvegarde de mailSkin"
    },    
    [types.ADM_MAIL_SKIN_RESET_STATUS]: (state) => {
        state.mailSkinStatus = ''
    },
    [types.ADM_MAIL_SKIN_DELETE_REQUEST]: state => {    
        state.mailSkinStatus = "Suppression de mailSkin"
    },
    [types.ADM_MAIL_SKIN_DELETE_SUCCESS]: (state, mailSkin:AloMailSkin) => {        
        const idx = state.mailSkinList.item.indexOf(mailSkin.id)
        if(idx > -1) state.mailSkinList.item.splice(idx ,1)
        delete state.mailSkinDic[mailSkin.id]                
        state.mailSkinStatus = "Suppression de mailSkin terminée"
    },
    [types.ADM_MAIL_SKIN_DELETE_ERROR]: (state,message:string) => {        
        state.mailSkinStatus = message??"Erreur lors de la Suppression de mailSkin"
    },

    //////////////////////////////////////////////////////////////////
    // PISCINE
    /////////////////////////////////////////////////////////////////

    [types.ADM_PISCINE_REQUEST]: state => {    
        state.piscineStatus = 'Chargement des piscine'
    },
    [types.ADM_PISCINE_SUCCESS]: (state, piscine:Array<AloPiscine>) => {        
        state.piscineDic = {...state.piscineDic, ...toNumberDictionary(piscine,f => f.id,getDefaultAloPiscine)}
        state.piscineList = buildStateItem(piscine.map(f => f.id))
        state.piscineStatus = 'Chargement des piscine terminé'
    },
    [types.ADM_PISCINE_ERROR]: (state,message:string) => {        
        state.piscineStatus = message??'Erreur lors du chargement des piscine'
    },
    [types.ADM_PISCINE_DETAIL_REQUEST]: state => {    
        state.piscineStatus = "Chargement du detail de piscine"
    },
    [types.ADM_PISCINE_DETAIL_SUCCESS]: (state, piscine:AloPiscine) => {        
        Vue.set(state.piscineDic,piscine.id,{...getDefaultAloPiscine(),...piscine})
        state.piscineStatus = 'Chargement du detail piscine terminé'
    },
    [types.ADM_PISCINE_DETAIL_ERROR]: (state,message:string) => {        
        state.piscineStatus = message??'Erreur lors du chargement du detail piscine'
    },
    [types.ADM_PISCINE_SAVE_REQUEST]: state => {    
        state.piscineStatus = "Sauvegarde de piscine"
    },
    [types.ADM_PISCINE_SAVE_SUCCESS]: (state, piscine:AloPiscine) => {        
        Vue.set(state.piscineDic,piscine.id,{...getDefaultAloPiscine(),...piscine})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.piscineList.item.findIndex(n => n == piscine.id) == -1) state.piscineList.item.push(piscine.id)
        state.piscineStatus = "Sauvegarde de piscine terminée"
    },
    [types.ADM_PISCINE_SAVE_ERROR]: (state,message:string) => {        
        state.piscineStatus = message??"Erreur lors de la sauvegarde de piscine"
    },    
    [types.ADM_PISCINE_RESET_STATUS]: (state) => {
        state.piscineStatus = ''
    },
    [types.ADM_PISCINE_DELETE_REQUEST]: state => {    
        state.piscineStatus = "Suppression de piscine"
    },
    [types.ADM_PISCINE_DELETE_SUCCESS]: (state, piscine:AloPiscine) => {        
        const idx = state.piscineList.item.indexOf(piscine.id)
        if(idx > -1) state.piscineList.item.splice(idx ,1)
        delete state.piscineDic[piscine.id]                
        state.piscineStatus = "Suppression de piscine terminée"
    },
    [types.ADM_PISCINE_DELETE_ERROR]: (state,message:string) => {        
        state.piscineStatus = message??"Erreur lors de la Suppression de piscine"
    },

    ////////////////////////////////////////////////////////////////
    // ACTIVITY
    /////////////////////////////////////////////////////////////////

    [types.ADM_ACTIVITY_REQUEST]: state => {    
        state.activityStatus = 'Chargement des activity'
    },
    [types.ADM_ACTIVITY_SUCCESS]: (state, activity:Array<AloActivity>) => {        
        state.activityDic = {...state.activityDic, ...toNumberDictionary(activity,f => f.id,getDefaultAloActivity)}
        state.activityList = buildStateItem(activity.map(f => f.id))
        state.activityStatus = 'Chargement des activitéq terminé'
    },
    [types.ADM_ACTIVITY_ERROR]: (state,message:string) => {        
        state.activityStatus = message??'Erreur lors du chargement des activités'
    },
    [types.ADM_ACTIVITY_DETAIL_REQUEST]: state => {    
        state.activityStatus = "Chargement du detail de l'activité"
    },
    [types.ADM_ACTIVITY_DETAIL_SUCCESS]: (state, activity:AloActivity) => {        
        Vue.set(state.activityDic,activity.id,{...getDefaultAloActivity(),...activity})
        state.activityStatus = "Chargement du detail de l'activité terminé"
    },
    [types.ADM_ACTIVITY_DETAIL_ERROR]: (state,message:string) => {        
        state.activityStatus = message??"Erreur lors du chargement du detail de l'activité"
    },
    [types.ADM_ACTIVITY_SAVE_REQUEST]: state => {    
        state.activityStatus = "Sauvegarde de l'activité"
    },
    [types.ADM_ACTIVITY_SAVE_SUCCESS]: (state, activity:AloActivity) => {        
        Vue.set(state.activityDic,activity.id,{...getDefaultAloActivity(),...activity})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.activityList.item.findIndex(n => n == activity.id) == -1) state.activityList.item.push(activity.id)
        state.activityStatus = "Sauvegarde de l'activité terminée"
    },
    [types.ADM_ACTIVITY_SAVE_ERROR]: (state,message:string) => {        
        state.activityStatus = message??"Erreur lors de la sauvegarde de l'activité"
    },    
    [types.ADM_ACTIVITY_RESET_STATUS]: (state) => {
        state.activityStatus = ''
    },
    [types.ADM_ACTIVITY_DELETE_REQUEST]: state => {    
        state.activityStatus = "Suppression de l'activité"
    },
    [types.ADM_ACTIVITY_DELETE_SUCCESS]: (state, activity:AloActivity) => {        
        const idx = state.activityList.item.indexOf(activity.id)
        if(idx > -1) state.activityList.item.splice(idx ,1)
        delete state.activityDic[activity.id]                
        state.activityStatus = "Suppression de l'activité terminée"
    },
    [types.ADM_ACTIVITY_DELETE_ERROR]: (state,message:string) => {        
        state.activityStatus = message??"Erreur lors de la Suppression de l'activité"
    },  
    [types.ADM_ACTIVITY_SET_LIST]: (state, list:Array<number>) => {        
        state.activityList.item = list
    },

    //////////////////////////////////////////////////////////////////
    // FORFAIT
    /////////////////////////////////////////////////////////////////

    [types.ADM_FORFAIT_REQUEST]: state => {    
        state.forfaitStatus = 'Chargement des forfaits'
    },
    [types.ADM_FORFAIT_SUCCESS]: (state, forfait:Array<AloForfait>) => {        
        state.forfaitDic = {...state.forfaitDic, ...toNumberDictionary(forfait,f => f.id,getDefaultAloForfait)}
        state.forfaitList = buildStateItem(forfait.map(f => f.id))
        state.forfaitStatus = 'Chargement des forfaits terminé'
    },
    [types.ADM_FORFAIT_ERROR]: (state,message:string) => {        
        state.forfaitStatus = message??'Erreur lors du chargement des forfaits'
    },
    [types.ADM_FORFAIT_DETAIL_REQUEST]: state => {    
        state.forfaitStatus = "Chargement du detail de forfait"
    },
    [types.ADM_FORFAIT_DETAIL_SUCCESS]: (state, forfait:AloForfait) => {        
        Vue.set(state.forfaitDic,forfait.id,{...getDefaultAloForfait(),...forfait})
        state.forfaitStatus = 'Chargement du detail forfait terminé'
    },
    [types.ADM_FORFAIT_DETAIL_ERROR]: (state,message:string) => {        
        state.forfaitStatus = message??'Erreur lors du chargement du detail forfait'
    },
    [types.ADM_FORFAIT_SAVE_REQUEST]: state => {    
        state.forfaitStatus = "Sauvegarde de forfait"
    },
    [types.ADM_FORFAIT_SAVE_SUCCESS]: (state, forfait:AloForfait) => {        
        Vue.set(state.forfaitDic,forfait.id,{...getDefaultAloForfait(),...forfait})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.forfaitList.item.findIndex(n => n == forfait.id) == -1) state.forfaitList.item.push(forfait.id)
        state.forfaitStatus = "Sauvegarde de forfait terminée"
    },
    [types.ADM_FORFAIT_SAVE_ERROR]: (state,message:string) => {        
        state.forfaitStatus = message??"Erreur lors de la sauvegarde de forfait"
    },    
    [types.ADM_FORFAIT_RESET_STATUS]: (state) => {
        state.forfaitStatus = ''
    },
    [types.ADM_FORFAIT_DELETE_REQUEST]: state => {    
        state.forfaitStatus = "Suppression de forfait"
    },
    [types.ADM_FORFAIT_DELETE_SUCCESS]: (state, forfait:AloForfait) => {        
        const idx = state.forfaitList.item.indexOf(forfait.id)
        if(idx > -1) state.forfaitList.item.splice(idx ,1)
        delete state.forfaitDic[forfait.id]                
        state.forfaitStatus = "Suppression de forfait terminée"
    },
    [types.ADM_FORFAIT_DELETE_ERROR]: (state,message:string) => {        
        state.forfaitStatus = message??"Erreur lors de la Suppression de forfait"
    },

    //////////////////////////////////////////////////////////////////
    // MNS
    /////////////////////////////////////////////////////////////////

    [types.ADM_MNS_REQUEST]: state => {    
        state.mnsStatus = 'Chargement des mns'
    },
    [types.ADM_MNS_SUCCESS]: (state, mns:Array<AloMns>) => {        
        state.mnsDic = {...state.mnsDic, ...toNumberDictionary(mns,f => f.id,getDefaultAloMns)}
        state.mnsList = buildStateItem(mns.map(f => f.id))
        state.mnsStatus = 'Chargement des mns terminé'
    },
    [types.ADM_MNS_ERROR]: (state,message:string) => {        
        state.mnsStatus = message??'Erreur lors du chargement des mns'
    },
    [types.ADM_MNS_DETAIL_REQUEST]: state => {    
        state.mnsStatus = "Chargement du detail mns"
    },
    [types.ADM_MNS_DETAIL_SUCCESS]: (state, mns:AloMns) => {        
        Vue.set(state.mnsDic,mns.id,{...getDefaultAloMns(),...mns})
        state.mnsStatus = 'Chargement du detail mns terminé'
    },
    [types.ADM_MNS_DETAIL_ERROR]: (state,message:string) => {        
        state.mnsStatus = message??'Erreur lors du chargement du detail mns'
    },
    [types.ADM_MNS_SAVE_REQUEST]: state => {    
        state.mnsStatus = "Sauvegarde du mns"
    },
    [types.ADM_MNS_SAVE_SUCCESS]: (state, mns:AloMns) => {        
        Vue.set(state.mnsDic,mns.id,{...getDefaultAloMns(),...mns})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.mnsList.item.findIndex(n => n == mns.id) == -1) state.mnsList.item.push(mns.id)
        state.mnsStatus = "Sauvegarde du mns terminée"
    },
    [types.ADM_MNS_SAVE_ERROR]: (state,message:string) => {        
        state.mnsStatus = message??"Erreur lors de la sauvegarde du mns"
    },    
    [types.ADM_MNS_RESET_STATUS]: (state) => {
        state.mnsStatus = ''
    },
    [types.ADM_MNS_DELETE_REQUEST]: state => {    
        state.mnsStatus = "Suppression du mns"
    },
    [types.ADM_MNS_DELETE_SUCCESS]: (state, mns:AloMns) => {        
        const idx = state.mnsList.item.indexOf(mns.id)
        if(idx > -1) state.mnsList.item.splice(idx ,1)
        delete state.mnsDic[mns.id]                
        state.mnsStatus = "Suppression du mns terminée"
    },
    [types.ADM_MNS_DELETE_ERROR]: (state,message:string) => {        
        state.mnsStatus = message??"Erreur lors de la Suppression du mns"
    },

    //////////////////////////////////////////////////////////////////
    // CONTACT
    /////////////////////////////////////////////////////////////////

    [types.ADM_CONTACT_REQUEST]: state => {    
        state.contactStatus = 'Chargement des contact'
    },
    [types.ADM_CONTACT_SUCCESS]: (state, contact:Array<AloContact>) => {        
        state.contactDic = {...state.contactDic, ...toNumberDictionary(contact,f => f.id,getDefaultAloContact)}
        state.contactList = buildStateItem(contact.map(f => f.id))
        state.contactStatus = 'Chargement des contact terminé'
    },
    [types.ADM_CONTACT_ERROR]: (state,message:string) => {        
        state.contactStatus = message??'Erreur lors du chargement des contact'
    },
    [types.ADM_CONTACT_DETAIL_REQUEST]: state => {    
        state.contactStatus = "Chargement du detail de contact"
    },
    [types.ADM_CONTACT_DETAIL_SUCCESS]: (state, contact:AloContact) => {        
        Vue.set(state.contactDic,contact.id,{...getDefaultAloContact(),...contact})
        state.contactStatus = 'Chargement du detail contact terminé'
    },
    [types.ADM_CONTACT_DETAIL_ERROR]: (state,message:string) => {        
        state.contactStatus = message??'Erreur lors du chargement du detail contact'
    },
    [types.ADM_CONTACT_SAVE_REQUEST]: state => {    
        state.contactStatus = "Sauvegarde de contact"
    },
    [types.ADM_CONTACT_SAVE_SUCCESS]: (state, contact:AloContact) => {        
        Vue.set(state.contactDic,contact.id,{...getDefaultAloContact(),...contact})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.contactList.item.findIndex(n => n == contact.id) == -1) state.contactList.item.push(contact.id)
        state.contactStatus = "Sauvegarde de contact terminée"
    },
    [types.ADM_CONTACT_SAVE_ERROR]: (state,message:string) => {        
        state.contactStatus = message??"Erreur lors de la sauvegarde de contact"
    },    
    [types.ADM_CONTACT_RESET_STATUS]: (state) => {
        state.contactStatus = ''
    },
    [types.ADM_CONTACT_DELETE_REQUEST]: state => {    
        state.contactStatus = "Suppression de contact"
    },
    [types.ADM_CONTACT_DELETE_SUCCESS]: (state, contact:AloContact) => {        
        const idx = state.contactList.item.indexOf(contact.id)
        if(idx > -1) state.contactList.item.splice(idx ,1)
        delete state.contactDic[contact.id]                
        state.contactStatus = "Suppression de contact terminée"
    },
    [types.ADM_CONTACT_DELETE_ERROR]: (state,message:string) => {        
        state.contactStatus = message??"Erreur lors de la Suppression de contact"
    },
    [types.ADM_CONTACT_MIN_DATE_REQUEST]: state => {    
        state.contactStatus = "Recuperation min date des contacts"
    },
    [types.ADM_CONTACT_MIN_DATE_SUCCESS]: (state, minDate:string) => {         
        state.contactMinDate = minDate
        state.contactStatus = "Recuperation min date des contacts terminée"
    },
    [types.ADM_CONTACT_MIN_DATE_ERROR]: (state,message:string) => {        
        state.contactStatus = message??"Erreur lors de la recuperation min date des contacts"
    },    
    [types.ADM_CONTACT_ACTION_ON_SELECTION_REQUEST]: (state,payload:{conIds:Array<number>,action:string,data:string}) => {    
        state.contactStatus = `Execution de l'action ${payload.action} sur la selection`
    },
    [types.ADM_CONTACT_ACTION_ON_SELECTION_SUCCESS]: (state, param:{item:Array<AloContact>,payload:{conIds:Array<number>,action:string,data:string}}) => {                
        state.contactStatus = `Execution de l'action ${param.payload.action} sur la selection terminée`
        state.contactDic = {...state.contactDic, ...toNumberDictionary(param.item.map(it => {return {...it,selected:state.contactDic[it.id].selected}}),f => f.id,getDefaultAloContact)}              
    },
    [types.ADM_CONTACT_ACTION_ON_SELECTION_ERROR]: (state,payload:{conIds:Array<number>,action:string,data:string}) => {        
        state.contactStatus = `Erreur lors l'execution de l'action  ${payload.action} sur la selection`
    },
    [types.ADM_CONTACT_SET_SELECTION]: (state,{selected,ids}:{selected:boolean,ids:Array<number>}) => { 
        //on reconstruit comme ca et non en foreach car plus performant sur la reactivité      
        state.contactDic = {
            ...state.contactDic,
            ...ids.reduce((dic,id)=> {
                            dic[id] = {...state.contactDic[id],selected}
                            return dic
                    },{} as {[id:number]:AloContact
                }) 
        }         
    },

    //////////////////////////////////////////////////////////////////
    // NEWSLETTER
    /////////////////////////////////////////////////////////////////

    [types.ADM_NEWSLETTER_REQUEST]: state => {    
        state.newsletterStatus = 'Chargement des inscriptions newsletter'
    },
    [types.ADM_NEWSLETTER_SUCCESS]: (state, newsletter:Array<AloNewsletter>) => {        
        state.newsletterDic = {...state.newsletterDic, ...toNumberDictionary(newsletter,f => f.id,getDefaultAloNewsletter)}
        state.newsletterList = buildStateItem(newsletter.map(f => f.id))
        state.newsletterStatus = 'Chargement des inscriptions newsletter terminé'
    },
    [types.ADM_NEWSLETTER_ERROR]: (state,message:string) => {        
        state.newsletterStatus = message??'Erreur lors du chargement des inscriptions newsletter'
    },
    [types.ADM_NEWSLETTER_DETAIL_REQUEST]: state => {    
        state.newsletterStatus = "Chargement du detail de l'inscription newsletter"
    },
    [types.ADM_NEWSLETTER_DETAIL_SUCCESS]: (state, newsletter:AloNewsletter) => {        
        Vue.set(state.newsletterDic,newsletter.id,{...getDefaultAloNewsletter(),...newsletter})
        state.newsletterStatus = "Chargement du detail de l'inscription newsletter terminé"
    },
    [types.ADM_NEWSLETTER_DETAIL_ERROR]: (state,message:string) => {        
        state.newsletterStatus = message??"Erreur lors du chargement du detail de l'inscription  newsletter"
    },
    [types.ADM_NEWSLETTER_SAVE_REQUEST]: state => {    
        state.newsletterStatus = "Sauvegarde de l'inscription newsletter"
    },
    [types.ADM_NEWSLETTER_SAVE_SUCCESS]: (state, newsletter:AloNewsletter) => {        
        Vue.set(state.newsletterDic,newsletter.id,{...getDefaultAloNewsletter(),...newsletter})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.newsletterList.item.findIndex(n => n == newsletter.id) == -1) state.newsletterList.item.push(newsletter.id)
        state.newsletterStatus = "Sauvegarde de l'inscription newsletter terminée"
    },
    [types.ADM_NEWSLETTER_SAVE_ERROR]: (state,message:string) => {        
        state.newsletterStatus = message??"Erreur lors de la sauvegarde de l'inscription newsletter"
    },    
    [types.ADM_NEWSLETTER_RESET_STATUS]: (state) => {
        state.newsletterStatus = ''
    },
    [types.ADM_NEWSLETTER_DELETE_REQUEST]: state => {    
        state.newsletterStatus = "Suppression de l'inscription newsletter"
    },
    [types.ADM_NEWSLETTER_DELETE_SUCCESS]: (state, newsletter:AloNewsletter) => {        
        const idx = state.newsletterList.item.indexOf(newsletter.id)
        if(idx > -1) state.newsletterList.item.splice(idx ,1)
        delete state.newsletterDic[newsletter.id]                
        state.newsletterStatus = "Suppression de l'inscription newsletter terminée"
    },
    [types.ADM_NEWSLETTER_DELETE_ERROR]: (state,message:string) => {        
        state.newsletterStatus = message??"Erreur lors de la Suppression de l'inscription de newsletter"
    },
    [types.ADM_NEWSLETTER_VALID_REQUEST]: state => {    
        state.newsletterStatus = "Demande de validation newsletter"
    },
    [types.ADM_NEWSLETTER_VALID_SUCCESS]: (state, newsletter:AloNewsletter) => {            
        state.newsletterStatus = "Demande de validation newsletter terminée"
    },
    [types.ADM_NEWSLETTER_VALID_ERROR]: (state,message:string) => {        
        state.newsletterStatus = message??"Erreur lors de la demande de validation newsletter"
    },    
    [types.ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST]: (state,payload:{nwlIds:Array<number>,action:string,data:string}) => {    
        state.newsletterStatus = `Execution de l'action ${payload.action} sur la selection`
    },
    [types.ADM_NEWSLETTER_ACTION_ON_SELECTION_SUCCESS]: (state, param:{item:Array<AloNewsletter>,payload:{nwlIds:Array<number>,action:string,data:string}}) => {                
        state.newsletterStatus = `Execution de l'action ${param.payload.action} sur la selection terminée`
        state.newsletterDic = {...state.newsletterDic, ...toNumberDictionary(param.item.map(it => {return {...it,selected:state.newsletterDic[it.id].selected}}),f => f.id,getDefaultAloNewsletter)}              
    },
    [types.ADM_NEWSLETTER_ACTION_ON_SELECTION_ERROR]: (state,payload:{nwlIds:Array<number>,action:string,data:string}) => {        
        state.newsletterStatus = `Erreur lors l'execution de l'action  ${payload.action} sur la selection`
    },
    [types.ADM_NEWSLETTER_SET_SELECTION]: (state,{selected,ids}:{selected:boolean,ids:Array<number>}) => { 
        //on reconstruit comme ca et non en foreach car plus performant sur la reactivité      
        state.newsletterDic = {
            ...state.newsletterDic,
            ...ids.reduce((dic,id)=> {
                            dic[id] = {...state.newsletterDic[id],selected}
                            return dic
                    },{} as {[id:number]:AloNewsletter
                }) 
        }         
    },
    //////////////////////////////////////////////////////////////////
    // COURS
    /////////////////////////////////////////////////////////////////

    [types.ADM_COURS_REQUEST]: state => {    
        state.coursStatus = 'Chargement des cours'
    },
    [types.ADM_COURS_SUCCESS]: (state, cours:Array<AloCours>) => {        
        state.coursDic = {...state.coursDic, ...toNumberDictionary(cours,f => f.id,getDefaultAloCours)}
        state.coursList = buildStateItem(cours.map(f => f.id))
        state.coursStatus = 'Chargement des cours terminé'
    },
    [types.ADM_COURS_SUCCESS_DIC]: (state, cours:Array<AloCours>) => {        
        state.coursDic = {...state.coursDic, ...toNumberDictionary(cours,f => f.id,getDefaultAloCours)}        
        state.coursStatus = 'Chargement des cours terminé'
    },
    [types.ADM_COURS_ERROR]: (state,message:string) => {        
        state.coursStatus = message??'Erreur lors du chargement des cours'
    },
    [types.ADM_COURS_DETAIL_REQUEST]: state => {    
        state.coursStatus = "Chargement du detail de cours"
    },
    [types.ADM_COURS_DETAIL_SUCCESS]: (state, cours:AloCours) => {        
        Vue.set(state.coursDic,cours.id,{...getDefaultAloCours(),...cours})
        state.coursStatus = 'Chargement du detail cours terminé'
    },
    [types.ADM_COURS_DETAIL_ERROR]: (state,message:string) => {        
        state.coursStatus = message??'Erreur lors du chargement du detail cours'
    },
    [types.ADM_COURS_SAVE_REQUEST]: state => {    
        state.coursStatus = "Sauvegarde de cours"
    },
    [types.ADM_COURS_SAVE_SUCCESS]: (state, cours:AloCours) => {        
        Vue.set(state.coursDic,cours.id,{...getDefaultAloCours(),...cours})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.coursList.item.findIndex(n => n == cours.id) == -1) state.coursList.item.push(cours.id)
        state.coursStatus = "Sauvegarde de cours terminée"
    },
    [types.ADM_COURS_SAVE_SUCCESS_DIC]: (state, cours:AloCours) => {        
        Vue.set(state.coursDic,cours.id,{...getDefaultAloCours(),...cours,selected:true})                
        state.coursStatus = "Génération du cours terminée"
    },    
    [types.ADM_COURS_CREATE_RANGE_SUCCESS]: (state, cours:Array<AloCours>) => {        
        state.coursDic = {...state.coursDic, ...toNumberDictionary(cours,f => f.id,() => { return {...getDefaultAloCours(),selected:true}})}        
        state.coursStatus = 'Générations des cours terminé'
    },    
    [types.ADM_COURS_SAVE_ERROR]: (state,message:string) => {        
        state.coursStatus = message??"Erreur lors de la sauvegarde de cours"
    },    
    [types.ADM_COURS_RESET_STATUS]: (state) => {
        state.coursStatus = ''
    },
    [types.ADM_COURS_DELETE_REQUEST]: state => {    
        state.coursStatus = "Suppression de cours"
    },
    [types.ADM_COURS_DELETE_SUCCESS]: (state, cours:AloCours) => {        
        const idx = state.coursList.item.indexOf(cours.id)
        if(idx > -1) state.coursList.item.splice(idx ,1)
        delete state.coursDic[cours.id]                
        state.coursStatus = "Suppression de cours terminée"
    },
    [types.ADM_COURS_DELETE_ERROR]: (state,message:string) => {        
        state.coursStatus = message??"Erreur lors de la Suppression de cours"
    },
    
    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////

    [types.ADM_COMMANDE_REQUEST]: state => {    
        state.commandeStatus = 'Chargement des commande'
    },
    [types.ADM_COMMANDE_SUCCESS]: (state, commande:Array<AloCommande>) => {        
        state.commandeDic = {...state.commandeDic, ...toNumberDictionary(commande,f => f.id,getDefaultAloCommande)}
        state.commandeList = buildStateItem(commande.map(f => f.id))
        state.commandeStatus = 'Chargement des commande terminé'
    },
    [types.ADM_COMMANDE_ERROR]: (state,message:string) => {        
        state.commandeStatus = message??'Erreur lors du chargement des commande'
    },
    [types.ADM_COMMANDE_DETAIL_REQUEST]: state => {    
        state.commandeStatus = "Chargement du detail de commande"
    },
    [types.ADM_COMMANDE_DETAIL_SUCCESS]: (state, commande:AloCommande) => {        
        Vue.set(state.commandeDic,commande.id,{...getDefaultAloCommande(),...commande})
        state.commandeStatus = 'Chargement du detail commande terminé'
    },
    [types.ADM_COMMANDE_DETAIL_ERROR]: (state,message:string) => {        
        state.commandeStatus = message??'Erreur lors du chargement du detail commande'
    },
    [types.ADM_COMMANDE_SAVE_REQUEST]: state => {    
        state.commandeStatus = "Sauvegarde de commande"
    },
    [types.ADM_COMMANDE_SAVE_SUCCESS]: (state, commande:AloCommande) => {        
        Vue.set(state.commandeDic,commande.id,{...getDefaultAloCommande(),...commande})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.commandeList.item.findIndex(n => n == commande.id) == -1) state.commandeList.item.push(commande.id)
        state.commandeStatus = "Sauvegarde de commande terminée"
    },
    [types.ADM_COMMANDE_SAVE_ERROR]: (state,message:string) => {        
        state.commandeStatus = message??"Erreur lors de la sauvegarde de commande"
    },    
    [types.ADM_COMMANDE_RESET_STATUS]: (state) => {
        state.commandeStatus = ''
    },
    [types.ADM_COMMANDE_DELETE_REQUEST]: state => {    
        state.commandeStatus = "Suppression de commande"
    },
    [types.ADM_COMMANDE_DELETE_SUCCESS]: (state, commande:AloCommande) => {        
        const idx = state.commandeList.item.indexOf(commande.id)
        if(idx > -1) state.commandeList.item.splice(idx ,1)
        delete state.commandeDic[commande.id]                
        state.commandeStatus = "Suppression de commande terminée"
    },
    [types.ADM_COMMANDE_DELETE_ERROR]: (state,message:string) => {        
        state.commandeStatus = message??"Erreur lors de la Suppression de commande"
    },
    [types.ADM_COMMANDE_MIN_DATE_REQUEST]: state => {    
        state.commandeStatus = "Recuperation min date des commandes"
    },
    [types.ADM_COMMANDE_MIN_DATE_SUCCESS]: (state, minDate:string) => {         
        state.commandeMinDate = minDate
        state.commandeStatus = "Recuperation min date des commandes terminée"
    },
    [types.ADM_COMMANDE_MIN_DATE_ERROR]: (state,message:string) => {        
        state.commandeStatus = message??"Erreur lors de la recuperation min date des commandes"
    },  

    //////////////////////////////////////////////////////////////////
    // FAMILY
    /////////////////////////////////////////////////////////////////

    [types.ADM_FAMILY_REQUEST]: state => {    
        state.familyStatus = 'Chargement des family'
    },
    [types.ADM_FAMILY_SUCCESS]: (state, family:Array<AloFamily>) => {        
        state.familyDic = {...state.familyDic, ...toNumberDictionary(family,f => f.id,getDefaultAloFamily)}
        state.familyList = buildStateItem(family.map(f => f.id))
        state.familyStatus = 'Chargement des family terminé'
    },
    [types.ADM_FAMILY_ERROR]: (state,message:string) => {        
        state.familyStatus = message??'Erreur lors du chargement des family'
    },
    [types.ADM_FAMILY_DETAIL_REQUEST]: state => {    
        state.familyStatus = "Chargement du detail de family"
    },
    [types.ADM_FAMILY_DETAIL_SUCCESS]: (state, family:AloFamily) => {        
        Vue.set(state.familyDic,family.id,{...getDefaultAloFamily(),...family})
        state.familyStatus = 'Chargement du detail family terminé'
    },
    [types.ADM_FAMILY_DETAIL_ERROR]: (state,message:string) => {        
        state.familyStatus = message??'Erreur lors du chargement du detail family'
    },
    [types.ADM_FAMILY_SAVE_REQUEST]: state => {    
        state.familyStatus = "Sauvegarde de family"
    },
    [types.ADM_FAMILY_SAVE_SUCCESS]: (state, family:AloFamily) => {        
        Vue.set(state.familyDic,family.id,{...getDefaultAloFamily(),...family})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.familyList.item.findIndex(n => n == family.id) == -1) state.familyList.item.push(family.id)
        state.familyStatus = "Sauvegarde de family terminée"
    },
    [types.ADM_FAMILY_SAVE_ERROR]: (state,message:string) => {        
        state.familyStatus = message??"Erreur lors de la sauvegarde de family"
    },    
    [types.ADM_FAMILY_RESET_STATUS]: (state) => {
        state.familyStatus = ''
    },
    [types.ADM_FAMILY_DELETE_REQUEST]: state => {    
        state.familyStatus = "Suppression de family"
    },
    [types.ADM_FAMILY_DELETE_SUCCESS]: (state, family:AloFamily) => {        
        const idx = state.familyList.item.indexOf(family.id)
        if(idx > -1) state.familyList.item.splice(idx ,1)
        delete state.familyDic[family.id]                
        state.familyStatus = "Suppression de family terminée"
    },
    [types.ADM_FAMILY_DELETE_ERROR]: (state,message:string) => {        
        state.familyStatus = message??"Erreur lors de la Suppression de family"
    },

}

export default mutations